// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3fEMT","dragIcon":"Choice_dragIcon__1XIjs","left":"Choice_left__3aIVr","input":"Choice_input__3h6_Q"};